<template>
  <v-card outlined class="pa-2 my-4" style="background-color: #fff8e1">
    <v-row class="warning-header" align="center" @click="toggleExpand">
      <v-col cols="auto" class="mx-3">
        <h2 style="color:black;">
          {{ $t("deforestation.complianceRiskWarnings") }} ({{ warningCount }})
          <v-tooltip top color="00BD73" max-width="350">
            <template v-slot:activator="{ on, attrs }">
              <v-icon class="icon-with-background" style="color:#0EBF67" v-bind="attrs" v-on="on">
                mdi-alert-circle
              </v-icon>
            </template>
            <span>{{ $t("deforestation.complianceRiskWarningsInfo") }}</span>
          </v-tooltip>
        </h2>
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="auto">
        <v-btn icon>
          <v-icon>{{ isExpanded ? "mdi-menu-up" : "mdi-menu-down" }}</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-expand-transition>
      <div v-show="isExpanded">
        <ul class="ma-3">
          <li v-for="(warning, index) in warnings" :key="index">
            <p> <span class="warning-title" @click="gotoTab(warning.assessmentName)">{{ warningTitle(warning.assessmentName) }}
                :</span> <span>{{ warning.count }}</span> <span>{{ $t("deforestation.issueFound") }}</span></p>
          </li>
        </ul>
      </div>
    </v-expand-transition>
  </v-card>
</template>

<script>
export default {
  props: {
    warnings: {
      type: Array,
      required: true,
    },
    diligenceId: {
      required: false,
      type: Number,
    }
  },
  computed: {
    warningCount() {
      return this.warnings.reduce((acc, warning) => acc + warning.count, 0);
    },
  },
  data() {
    return {
      isExpanded: false,
    };
  },

  watch: {
    warnings: {
      immediate: true,
      handler(newWarnings) {
        const key = `warnings_${this.diligenceId}`;
        // Store in localStorage
        localStorage.setItem(key, JSON.stringify(newWarnings));
      },
    },
  },

  methods: {
    warningTitle(assessmentName) {
      if(assessmentName === 'Location Verification'){
        return this.$t(`deforestation.locationVerification`);
      } else if(assessmentName === 'EUDR Deforestation Assessment'){
        return this.$t(`deforestation.EUDRDeforestationAssessment`);
      }
      return assessmentName;
    },
    toggleExpand() {
      this.isExpanded = !this.isExpanded;
    },

    getWarningMessage(warning) {
      if(typeof warning === 'object') return warning.message;
      return warning;
    },
    gotoTab(tabName) {
      this.$emit('gotoTab', tabName);
    }
  },
};
</script>
<style scoped lang="scss">
.warning-title {
  font-size: 16px;
  font-weight: 700;
  text-decoration: underline ;
  color: #00BD73;
  text-transform: capitalize;
  cursor: pointer;
}
.warning-header{
  cursor: pointer;
}
.info-icon{
  margin-left: 10px;
  margin-bottom: 10px;
}
</style>